//
//  lib/routing/noRedirectRoutes.ts
//  TownLIT
//
//  Created by Hossein Sakkaki on 2026-08-19.
//  Last Update by Hossein Sakkaki on 2026-10-19.
//

// Existing prefix behavior must remain unchanged.
export const NO_REDIRECT_PREFIXES = [
  "/townlit-official",
  "/townlit-official/support",
  "/townlit-official/install-app",
  "/payment",
  "/content",
  "/auth",
  "/feedback",
  "/pwa",
  "/lit",
  "/wayhood/",
];

// Exact routes must not match unrelated paths.
export const NO_REDIRECT_EXACT_ROUTES = [
  "/app",
  "/wayhood",
];
